import {
  omitUIFields,
  convertToObject,
  generateTrigger,
  extractCredentials,
} from '@/util/action-types';
import { getExternalWorkflowActivatorCreds } from '@/util/workflowDetails';
import Cookies from "js-cookie";

const updateWorkflow = async (
    { commit, rootGetters, dispatch, state },
    { loader = true, overwriteVersion = false, commitMessage, versionName, versionDescription } = {}
) => {
  if (loader) commit('SET_UPDATE_WORKFLOW_UPDATING', true);
  try {
    const customer = rootGetters['customer/CUSTOMER'];
    const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];
    const allCredentials = rootGetters['credentials/AUTHENTICATIONS'];
    const selectedVersion = rootGetters['workflows/details/WORKFLOW_SELECTED_VERSION'];
    const { startSettings, nodes, workflow, credentials, alertSettings, s3StorageEnabled } = state;

    let url = `/proxy/update-workflow/`;
    let customer_id = customer.customer_id;
    if (customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    const nodeList = omitUIFields(nodes);
    const nodesObj = convertToObject(nodeList);
    const actionCredentials = extractCredentials(nodesObj);
    const externalActivatorCredentials = getExternalWorkflowActivatorCreds(
        credentials,
        allCredentials
    );

    const IOStorageType = s3StorageEnabled ? 's3' : 'common'

    const updatedWorkflow = {
      commitMessage,
      versionName,
      versionDescription,
      customer_id,
      workflow_id: workflow.id,
      user_id: Cookies.get('userId'),
      overwriteVersion,
      updatedFields: {
        selectedVersion: selectedVersion.id,
        trigger_type: startSettings.trigger_type,
        trigger: generateTrigger(startSettings),
        actions: nodesObj,
        name: workflow.name,
        description: workflow.description,
        credentials: [
          ...actionCredentials,
          ...externalActivatorCredentials.map((c) => c.id),
        ],
        alertSettings: alertSettings,
        IOStorageType,
      },
    };

    const response = await window.axios.post(url, updatedWorkflow);
    if (response && response.data.success) {
      if(response.data.version) {
        commit('SET_WORKFLOW_SELECT_VERSION', response.data.version)
        commit('UPDATE_WORKFLOW_VERSION_LIST', response.data.version)
      }
      dispatch('notifications/pushNotification', 'Workflow updated', {
        root: true,
      });
      commit('SYNC_WORKFLOW_SAVED_STATE');
      commit('WORKFLOW_EDITED', false);
      return { success: true, workflowId: workflow.id };
    } else {
      const message = response?.data?.message || 'Failed to update workflow';
      dispatch('notifications/setError', message, { root: true });
      return { success: false, message, workflowId: workflow.id };
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
    return { success: false, message: error.message };
  } finally {
    commit('SET_UPDATE_WORKFLOW_UPDATING', false);
  }
};

export default updateWorkflow;
